import { render, staticRenderFns } from "./BrowserGuard.vue?vue&type=template&id=38b5b6fa&scoped=true&"
import script from "./BrowserGuard.vue?vue&type=script&lang=js&"
export * from "./BrowserGuard.vue?vue&type=script&lang=js&"
import style0 from "./BrowserGuard.vue?vue&type=style&index=0&id=38b5b6fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5b6fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
